import AxiosControl from '../../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getTemplates = (page = null, limit = null, search = '') => async (dispatch) => {
    dispatch({ type: 'TEMPLATE_LOADING' })
    try {
        const { data, status } = await Axios.post('/api/template/getall/', { page, limit, search }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'TEMPLATE_GETALL_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'TEMPLATE_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'TEMPLATE_NOT_LOADING' })
    }
}

export const getTemplate = (template) => async (dispatch) => {
    dispatch({ type: 'TEMPLATE_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/template/get/' + template, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'TEMPLATE_GET_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'TEMPLATE_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'TEMPLATE_NOT_LOADING' })
    }
}

export const addTemplate = (templatedata) => async (dispatch) => {
    try {
        const { data, status } = await Axios.post('/api/template/register', templatedata, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'TEMPLATE_ADD_SUCCESS',
                payload: data
            })
        } else if (status === 264 || status === 260) {
            dispatch({
                type: 'TEMPLATE_WRONG_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'TEMPLATE_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'TEMPLATE_NOT_LOADING' })
    }
}

export const editTemplate = (templatedata, template) => async (dispatch) => {
    try {
        const { data, status } = await Axios.put('/api/template/edit/' + template, templatedata, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200 || status === 264) {
            dispatch({
                type: 'TEMPLATE_EDIT_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({ type: 'TEMPLATE_NOT_LOADING' })
    }
}